/**
 * Maps DB `all_app_templates.app_type` → customer portal route + label.
 * Keep aligned with Create* pages (formData `app_type`) and `customerRoutes.js`.
 */
const ENTRIES = {
    AI_ChatBot: { label: 'AI Chatbot', customerPath: '/customer/apps/ai-chatbot' },
    Airbnb_Review: { label: 'Airbnb Reviews', customerPath: '/customer/apps/airbnb-reviews' },
    AliExpress_Review: { label: 'AliExpress Reviews', customerPath: '/customer/apps/aliexpress-reviews' },
    Amazon_Review: { label: 'Amazon Reviews', customerPath: '/customer/apps/amazon-reviews' },
    Announcement_Bar: { label: 'Announcement Bar', customerPath: '/customer/apps/announcement-bar' },
    AppStore_Review: { label: 'App Store Reviews', customerPath: '/customer/apps/app-store-reviews' },
    Age_Verification: { label: 'Age Verification', customerPath: '/customer/apps/age-verification' },
    Back_To_Top: { label: 'Back to Top', customerPath: '/customer/apps/back-to-top' },
    Bbb_Review: { label: 'BBB Reviews', customerPath: '/customer/apps/bbb-reviews' },
    Booking_Review: { label: 'Booking.com Reviews', customerPath: '/customer/apps/booking-reviews' },
    Business_Hours: { label: 'Business Hours', customerPath: '/customer/apps/business-hours' },
    Capterra_Review: { label: 'Capterra Reviews', customerPath: '/customer/apps/capterra-reviews' },
    Click_To_Call: { label: 'Click to Call', customerPath: '/customer/apps/click-to-call' },
    Cookie_Consent: { label: 'Cookie Consent', customerPath: '/customer/apps/cookie-consent' },
    Countdown_Timer: { label: 'Countdown Timer', customerPath: '/customer/apps/countdown-timer' },
    Etsy_Review: { label: 'Etsy Reviews', customerPath: '/customer/apps/etsy-reviews' },
    Facebook_Chat: { label: 'Facebook Chat', customerPath: '/customer/apps/facebook-chat' },
    Facebook_Like_Button: { label: 'Facebook Like Button', customerPath: '/customer/apps/facebook-like-button' },
    Facebook_Review: { label: 'Facebook Reviews', customerPath: '/customer/apps/facebook-reviews' },
    Facebook_Share_Button: { label: 'Facebook Share Button', customerPath: '/customer/apps/facebook-share-button' },
    Faq: { label: 'FAQ', customerPath: '/customer/apps/faq' },
    File_Embed: { label: 'File Embed', customerPath: '/customer/apps/file-embed' },
    G2_Review: { label: 'G2 Reviews', customerPath: '/customer/apps/g2-reviews' },
    Google_Review: { label: 'Google Reviews', customerPath: '/customer/apps/google-reviews' },
    Hotels_Review: { label: 'Hotels.com Reviews', customerPath: '/customer/apps/hotels-reviews' },
    Instagram_Chat: { label: 'Instagram Chat', customerPath: '/customer/apps/instagram-chat' },
    Instagram_Feed: { label: 'Instagram Feed', customerPath: '/customer/apps/instagram-feed' },
    Line_Chat: { label: 'LINE Chat', customerPath: '/customer/apps/line-chat' },
    Logo_Showcase: { label: 'Logo Showcase', customerPath: '/customer/apps/logo-showcase' },
    Number_Counter: { label: 'Number Counter', customerPath: '/customer/apps/number-counter' },
    Open_Table_Review: { label: 'OpenTable Reviews', customerPath: '/customer/apps/opentable-reviews' },
    PayPal_Button: { label: 'PayPal Button', customerPath: '/customer/apps/paypal-button' },
    Pdf_Embed: { label: 'PDF Embed', customerPath: '/customer/apps/pdf-embed' },
    Photo_Gallery: { label: 'Photo Gallery', customerPath: '/customer/apps/photo-gallery' },
    Pricing_Table: { label: 'Pricing Table', customerPath: '/customer/apps/pricing-table' },
    QR_Code: { label: 'QR Code', customerPath: '/customer/apps/qr-code' },
    Social_Media_Icons: { label: 'Social Media Icons', customerPath: '/customer/apps/social-media-icons' },
    Spinning_Wheel: { label: 'Spinning Wheel', customerPath: '/customer/apps/spinning-wheel' },
    Team_Showcase: { label: 'Team Showcase', customerPath: '/customer/apps/team-showcase' },
    Telegram_Chat: { label: 'Telegram Chat', customerPath: '/customer/apps/telegram-chat' },
    Testimonial_Slider: { label: 'Testimonials', customerPath: '/customer/apps/testimonials' },
    Tripadvisor_Review: { label: 'Tripadvisor Reviews', customerPath: '/customer/apps/tripadvisor-reviews' },
    Viber_Chat: { label: 'Viber Chat', customerPath: '/customer/apps/viber-chat' },
    Whats_App_Chat: { label: 'WhatsApp Chat', customerPath: '/customer/apps/whats-app-chat' },
    Yelp_Review: { label: 'Yelp Reviews', customerPath: '/customer/apps/yelp-reviews' },
};

function humanizeAppType(appType) {
    if (!appType) return 'Unknown';
    return String(appType)
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (c) => c.toUpperCase());
}

/** @param {string} appType */
export function getAdminRouteForAppType(appType) {
    const row = ENTRIES[appType];
    if (row) {
        return { label: row.label, customerPath: row.customerPath, known: true };
    }
    return {
        label: humanizeAppType(appType),
        customerPath: null,
        known: false,
    };
}
